<template lang="pug">
lightbox(
  :active="active",
  :images="images",
  :initial-index="0",
  prev-icon="fa fa-chevron-left",
  next-icon="fa fa-chevron-right",
  close-icon="fa fa-close",
  @close="$emit('close')"
)
</template>

<script>
export default {
  vuex: {
    docs: { state: ["current"] },
  },
  props: {
    images: { type: Array, required: true },
    active: { type: Boolean, default: false },
  },
};
</script>
